const FileExtensions = {
  pdf: ['.pdf'],
  text: ['.doc', '.docx', '.odt', '.pdf', '.rtf', '.tex', '.txt', '.wpd'],
  spreadsheet: [
    '.ods',
    '.xls',
    '.xlsx',
    '.xlsm',
    '.csv',
    '.dat',
    '.db',
    '.dbf',
    '.log',
    '.mdb',
    '.sav',
    '.sql',
    '.tar',
    '.xml',
  ],
  code: [
    '.asp',
    '.aspx',
    '.cer',
    '.cfm',
    '.cgi',
    '.pl',
    '.css',
    '.htm',
    '.html',
    '.js',
    '.jsf',
    '.part',
    '.php',
    '.py',
    '.rss',
    '.xhtml',
    '.xml',
  ],
  archive: [
    '.7z',
    '.arj',
    '.deb',
    '.pkg',
    '.rar',
    '.rpm',
    '.tar.gz',
    '.z',
    '.zip',
  ],
  presentation: [
    '.key',
    '.odp',
    '.pps',
    '.ppt',
    '.pptx',
    '.3g2',
    '.3gp',
    '.avi',
    '.flv',
    '.h264',
    '.m4v',
    '.mkv',
    '.mov',
    '.mp4',
    '.mpg',
    '.mpeg',
    '.rm',
    '.swf',
    '.vob',
    '.webm',
    '.wmv',
    '.aif',
    '.cda',
    '.mid',
    '.midi',
    '.mp3',
    '.mpa',
    '.ogg',
    '.wav',
    '.wma',
    '.wpl',
  ],
  image: [
    '.bmp',
    '.gif',
    '.ico',
    '.jpeg',
    '.jpg',
    '.png',
    '.ps',
    '.psd',
    '.scr',
    '.tif',
    '.tiff',
    '.webp',
  ],
  vector: ['.svg', '.eps', '.ai', '.cdr'],
  font: ['.fnt', '.fon', '.otf', '.ttf'],
}
export const isPdf = (extension: string) =>
  FileExtensions.pdf.includes(extension)

export const isText = (extension: string) =>
  FileExtensions.text.includes(extension)

export const isSpreadsheet = (extension: string) =>
  FileExtensions.spreadsheet.includes(extension)

export const isCode = (extension: string) =>
  FileExtensions.code.includes(extension)

export const isArchive = (extension: string) =>
  FileExtensions.archive.includes(extension)

export const isPresentation = (extension: string) =>
  FileExtensions.presentation.includes(extension)

export const isImage = (extension: string) =>
  FileExtensions.image.includes(extension)

export const isVector = (extension: string) =>
  FileExtensions.vector.includes(extension)

export const isFont = (extension: string) =>
  FileExtensions.font.includes(extension)
